module.exports = __webpack_public_path__ + "static/img/step3-active.f688c7b2.png";